export default "__VITE_ASSET__c8c8af21__"